import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {SuppliersService} from '../../../services/suppliers.service';
import {Observable} from 'rxjs';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {MatSelectionList} from '@angular/material/list';
import {APP_GUIDS, AppGuids} from '../../../app.guids';
import {CoreService, Param, ProleisObject, Types} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-import-prisma-documents',
  templateUrl: 'pm-import-prisma-documents.component.html'
})
export class PmImportPrismaDocumentsComponent implements OnInit {
  documents: Observable<ProleisObject[]>;
  withAi = false;

  @ViewChild('docList') private docList: MatSelectionList;

  constructor(private cs: CoreService, private supplierService: SuppliersService, private bs: MatBottomSheetRef,
              @Inject(MAT_BOTTOM_SHEET_DATA) private data, @Inject(APP_GUIDS) private guids: AppGuids) {
  }

  ngOnInit() {
    this.loadPrismaDocuments();
  }

  loadPrismaDocuments() {
    this.documents = this.supplierService.getPrismaDocuments(this.data.snr, this.withAi);
  }

  save() {
    const selected = this.docList.selectedOptions;
    const filter = selected.selected.map(option => option.value.DOKU_ID).join(',');
    const params: Param[] = [{
      name: 'REQUEST_ID_FILTER_VALUES',
      type: Types.TEXT,
      value: filter
    }];

    this.cs.executeAction(this.data.OBJECT_ID, '§' + this.guids.GUID_ACTION_IMPORT_PRISMA_DOCUMENTS, params).subscribe(result => {
      this.bs.dismiss(result);
    });
  }

  dismiss() {
    this.bs.dismiss();
  }
}
